import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicMemberStateService";
const store = {};
const mutations = {
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicMemberStateDetail = posts.data;
            state.topicMemberStateDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_TOPIC_MEMBER_STATE_LIST(state, posts) {
        state.topicMemberStateList = posts;
        state.topicMemberStateListIsLoading = false;
    },
    SET_TOPIC_MEMBER_STATE_LIST_SIMPLE(state, posts) {
        state.topicMemberStateListSimple = posts;
        state.topicMemberStateListSimpleIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicMemberStateDetailChanged = false;

        }
        else {
            alert(posts.errorMessage);
        }
    },
    DELETE_TOPIC_MEMBER_STATE(state) {
        state.topicMemberStateDeleted = true;
    },
    SAVE_ACCESSLIST_FOR_TOPIC_MEMBER_STATE(state, posts) {
        if (posts.success == true) {
            state.accessListForTopicMemberStateChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_ACCESSLIST_FOR_TOPIC_MEMBER_STATE(state, posts) {
        state.accessListForTopicMemberStateIsLoading = false;
        if (posts.success == true) {
            state.accessListForTopicMemberState = posts.wfAccessList;
            state.accessListForTopicMemberStateChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    topicMemberStateListIsLoading: false,
    topicMemberStateList: [],
    accessListForTopicMemberStateIsLoading: false,
    accessListForTopicMemberState: [],
    topicMemberStateListSimpleIsLoading: false,
    topicMemberStateListSimple: [],
    topicMemberStateDetail: {},
    topicMemberStateDetailChanged: false,
    accessListForTopicMemberStateChanged: false,
    topicMemberStateDeleted:false
};
const getters = {};
const actions = {
    getTopicMemberStateList({ commit }) {
        state.topicMemberStateListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TOPIC_MEMBER_STATE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicMemberStateListSimple({ commit }, data) {
        state.topicMemberStateListSimpleIsLoading = true;
        axios
            .get(baseUri + '/GetListSimple?ttyId=' + data.ttyId)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TOPIC_MEMBER_STATE_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getAccessListForTopicMemberState({ commit }, data) {
        state.accessListForTopicMemberStateIsLoading = false;
        axios
            .get(baseUri + '/GetAccessListForStatus?tmsId=' + data.tmsId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCESSLIST_FOR_TOPIC_MEMBER_STATE', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicMemberStateDetail({ commit }, data) {
        state.topicMemberStateListIsLoading = true;
        var formData = new FormData();
        formData.append("tmsId", data.tmsId);
        formData.append("ttyId", data.ttyId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveTopicMemberStateDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.topicMemberStateDetail));
        axios
            .post(baseUri + '/Update', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
    deleteTopicMemberState({ commit }, data) {
        var formData = new FormData();
        formData.append("tmsId", data.tmsId);

        axios
            .post(baseUri + '/Delete', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('DELETE_TOPIC_MEMBER_STATE');
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveAccessListForTopicMemberState({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.accessListForTopicMemberState));
        formData.append("tmsId", state.topicMemberStateDetail.TmsId);
        axios
            .post(baseUri + '/SaveAccessList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ACCESSLIST_FOR_TOPIC_MEMBER_STATE', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}